import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { TableWidgetComponentFactory } from '~/components/MyWorkspace/TableWidget';
import {
  TeamPerformanceWidgetTableRow,
  useTeamPerformanceWidget,
} from '~/scenes/MyWorkspace/components/Widgets/components/TeamPerformanceWidget/useTeamPerformanceWidget';

import { WidgetProps } from '../../data/widgets';

import { TableHeader } from './components/TableHeader';
import { TeamMemberPerformance as TeamPerformance } from './components/TeamMemberPerformance';

export interface TeamPerformanceWidgetProps extends WidgetProps {}

const TeamPerformanceWidgetComponent = TableWidgetComponentFactory({
  TableRowComponent: TeamPerformance,
  getIdentifier: (item: TeamPerformanceWidgetTableRow) => `${item.id}`,
  TableHeaderComponent: TableHeader,
  dataCy: 'team-performance-widget',
  allTableDialogProps: {
    maxWidth: 'lg',
    fullWidth: true,
  },
});

export const TeamPerformanceWidget: React.FC<TeamPerformanceWidgetProps> = ({
  title,
  config,
}) => {
  const { t } = useTranslation();

  const { tableRows, loading, failedToLoad, isTabDisabled } =
    useTeamPerformanceWidget(config);

  return (
    <TeamPerformanceWidgetComponent
      title={title || t('teamPerformance')}
      data={tableRows}
      loading={loading}
      failedToLoad={failedToLoad}
      noDataMessage={t('noPerformance')}
      isTabDisabled={isTabDisabled}
    />
  );
};
